import axios from "axios";
const instance = axios.create({
  baseURL: "https://api.relysia.com",
});

export default instance;

export const SERVICE_ID = "3a1958c1-929b-438b-8228-e9008501f703";
